"use client"

import { captureException } from "@sentry/nextjs"
import { useEffect } from "react"

/**
 * The Error Boundary error.
 */
interface ErrorWithDigest extends Error {
  digest?: string
}

/**
 * Helper function to handle exceptions thrown in error boundaries.
 */
export function useErrorCapture(
  error: ErrorWithDigest | null,
  /**
   * The source of the error. Required, so we can determine
   * which error boundary handled the error.
   */
  source: string,
  options?: {
    tags?: Record<string, string>
  }
) {
  useEffect(() => {
    if (!error) return

    // trace.getActiveSpan()?.recordException(error)

    captureException(error, {
      tags: {
        digest: error.digest,
        errorSource: source,
        ...options?.tags,
      },
    })
  }, [error, source, JSON.stringify(options)])
}
